import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CotistaService } from "../cotista.service";
import { ResultadoPaginado } from "src/app/model/resultado";
import { Cotista } from "src/app/model/cotista.model";
import { TipoCotistaEnum } from "src/app/model/tipo-cotista-enum";
import { BnMaskCnpj, BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";

@Component({
    selector: 'app-select-cotista',
    templateUrl: './select-cotista.component.html',
    styleUrls: ['./select-cotista.component.scss'],
    standalone: false
})
export class SelectCotistaComponent implements OnInit{
  texto = '';
  cotistas: Cotista[] = [];
  cotista: any;
  @Input() readonly = false;
  @Input() cnpjAgente: string;
  @Input() nomeNaLabel = true;
  @Input() cnpjNaLabel = true;
  // utilizado para ordenação da lista no backend e para pesquisa dentro do select
  @Input() tipoOrdenacaoEPesquisa: string = 'nome';
  @Input() labelForm: boolean;
  @Output() selecionado = new EventEmitter<Cotista>()

  constructor(
    private cotistaService: CotistaService,
    private bnPipeCnpj: BnPipeCnpj,
    private bnLoadingService:BnLoadingService) {}

  async getCotistas() {
    this.bnLoadingService.bloqueiaTela();
    this.cotistas = await this.cotistaService
      .getCotistas(this.texto, this.tipoOrdenacaoEPesquisa)
      .toPromise();
    this.cotista = this.cotistas.find(a => a.cnpj === this.cnpjAgente && a.tipoCotista === TipoCotistaEnum.AGENTE_FINANCEIRO)
    this.selecionar(this.cotista);
    this.bnLoadingService.liberaTela();

  }

  ngOnInit(): void {
      this.getCotistas();
  }

  getLabel(item: Cotista): string {
    return this.nomeNaLabel ? item.nome : item.sigla;
  }
  
  getLabelWithCnpj(item: Cotista): string {
    const cnpj = this.bnPipeCnpj.transform(item.cnpj);
    return this.cnpjNaLabel ? `[${cnpj}]` : '';
  }

  searchFn(event) {
    let {term, items} = event
    console.log(term, items)

    term = term.toLocaleLowerCase();
    return this.cotistas.findIndex(i => i.sigla.toLocaleLowerCase().includes(term));
  }

  selecionar(cotista) {
    this.selecionado.emit(cotista);
  }

  limparSelect(){
    this.cotista = null;
  }
}
